const validPhone = (phone) => {
  return phone.match(/^(0)[1-9](\d{2}){4}$/);
};

export default validPhone;
